import * as React from 'react';
import * as styles from './styles.css';

interface ISummaryProps {
  label: React.ReactNode;
}

export function Summary({ label, children }: React.PropsWithChildren<ISummaryProps>) {
  return (
    <div className={styles['container']}>
      <span className={styles['title']}>{label}</span>
      <div className={styles['content']}>{children}</div>
    </div>
  );
}
